<template>
  <div>
    <router-link :to="{name: 'page-create'}" class="button is-primary is-pulled-right">Create Page</router-link>

    <data-table :data-set="filteredPages" :page-length="50" :columns="[
            {name: 'Page', prop: 'name', type: 'text'},
            {name: 'Updated', prop: 'updated_at', type: 'date', sortable: false, filter: ['moment', ['from', 'now']]},
            {name: 'Created', prop: 'created_at', type: 'date', sortable: false, filter: ['moment', ['from', 'now']]},
        ]">
      <template slot="column_Page" slot-scope="props">
        <div class="level">
          <div class="level-left">
            <div class="level-item" style="min-width: 220px">
              <router-link :to="{name:'page', params:{id: props.row.id}}" v-if="getImage(props.row)">
                <img :src="getImage(props.row).thumbnail_path">
              </router-link>
            </div>
            <div class="level-item">
              <div style="max-width: 400px;">
                <router-link :to="{name:'page', params:{id: props.row.id}}">
                  {{ props.row.name }}{{ props.row.company !== null ? ' ('+props.row.company+' ONLY)' : ''}}
                </router-link>
                <br />
                /{{ props.row.slug }}
                <br />
                <span class="has-text-grey">{{ props.row.keywords }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="controls" slot-scope="props">
        <td slot="controls" class="has-text-right table-controls">
          <a v-if="props.row.enabled" @click="disablePage(props.row)" title="Disable Page">
            <span class="icon"><i class="fa fa-toggle-on"></i></span>
          </a>
          <a v-else="props.row.enabled" @click="enablePage(props.row)" title="Enable Page">
            <span class="icon"><i class="fa fa-toggle-off"></i></span>
          </a>
          <button :disabled="props.row.display_order <= 1"
                  @click="moveUp(props.row)"
                  type="button"
                  class="button is-small"
                  title="move up">
            <i class="fa fa-arrow-up"></i>
          </button>
          <button :disabled="props.row.display_order >= pages.length"
                  @click="moveDown(props.row)"
                  type="button"
                  class="button is-small"
                  title="move down">
            <i class="fa fa-arrow-down"></i>
          </button>
          <a class="delete" @click="deletePage(props.row)"></a>
          &nbsp;
          &nbsp;
        </td>
      </template>
    </data-table>

  </div>
</template>

<script>
import {mapGetters}             from "vuex";
import {SORT_PAGE, DELETE_PAGE} from "../../store/mutation-types"

export default {
  name: 'page-list',
  data() {
    return {}
  },
  computed: Object.assign({}, mapGetters(['pages', 'pageContents', 'images']), {
    filteredPages() {
      return this.pages.sort(function (a, b) {
        return a.display_order - b.display_order
      }).map((page) => {
        return Object.assign(page, { contents: this.pageContents.filter(content => content.page_id === page.id) })
      })
    }
  }),
  methods: {
    getImage(page) {
      return this.images.find(image => image.id === page.image_id)
    },
    moveUp(page) {
      if (page.display_order <= 1) return false
      this.$store.dispatch(SORT_PAGE, {
        'id': page.id,
        'display_order': page.display_order - 1,
      })
    },
    moveDown(page) {
      if (page.display_order >= this.filteredPages[this.filteredPages.length - 1].display_order) return false
      this.$store.dispatch(SORT_PAGE, {
        'id': page.id,
        'display_order': page.display_order + 1
      })
    },
    deletePage(page) {
      let confirm = window.confirm('Are you sure?')

      if (confirm) {
        this.$store.dispatch(DELETE_PAGE, page)
      }
    },
    enablePage(page) {
      let pageUpdate            = { fields: JSON.parse(JSON.stringify(page)) }
      pageUpdate.fields.enabled = true
      this.$store.dispatch('UPDATE_PAGE', pageUpdate)
    },
    disablePage(page) {
      let pageUpdate            = { fields: JSON.parse(JSON.stringify(page)) }
      pageUpdate.fields.enabled = false
      this.$store.dispatch('UPDATE_PAGE', pageUpdate)
    }
  }
}
</script>



// WEBPACK FOOTER //
// PageList.vue?c35b4256